module.exports = __webpack_public_path__ + "img/导航logo.84e5b0ff.png";